export default "__VITE_ASSET__DrZVMAMX__"